export default [
    {
      path: '/admin/currencies',
      name: 'currencies',
      meta: { requiresAuth: true },
      component: () => import('@/pages/exchange-rate/currency/index.vue')
    }
  ]
  